exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert.alert-help[data-v-498beeaa]{background:#dcecf6;color:#406f8c;margin-left:15px;margin-right:15px}.alert.alert-warning[data-v-498beeaa]{background:red;color:#fff;margin-left:15px;margin-right:15px;font-size:14px;font-weight:400}.alert .close[data-v-498beeaa],.info-box .close[data-v-498beeaa]{color:#406f8c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-498beeaa","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/services/Home.vue
// module id = 495
// module chunks = 0